import { Theme } from '@mui/material'

const useStyles = {
  navButton: (theme: Theme) => ({
    color: theme.palette.info.dark,
  }),
  navButtonDivider: (theme: Theme) => ({
    color: theme.palette.info.dark,
    margin: theme.spacing(0, 4),
  }),
}
export default useStyles
